
define(['jquery', 'core'], function($, core) {
  var emptyOptionText, option, prepareOptions, preparedOptions, regionSelect;
  regionSelect = null;
  emptyOptionText = null;
  preparedOptions = {};
  option = function(value, text, selectedValue) {
    return "<option value='" + value + "' " + (selectedValue === value ? 'selected="selected"' : '') + ">" + text + "</option>";
  };
  prepareOptions = function(selectedValue) {
    var region, _i, _len, _ref, _results;
    _ref = core.getCollection('regions').toJSON();
    _results = [];
    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
      region = _ref[_i];
      if (preparedOptions[region.countryCode] == null) {
        preparedOptions[region.countryCode] = '';
      }
      if (region.regionCode) {
        _results.push(preparedOptions[region.countryCode] += option(region.regionCode, region.name, selectedValue));
      } else {
        _results.push(void 0);
      }
    }
    return _results;
  };
  return {
    init: function(select, text, selectedValue) {
      preparedOptions = {};
      prepareOptions(selectedValue);
      regionSelect = select;
      return emptyOptionText = text;
    },
    redrawOptions: function(countryCode) {
      var options;
      $(regionSelect).html('');
      options = preparedOptions[countryCode];
      if (options) {
        if (emptyOptionText) {
          options = option('', emptyOptionText) + options;
        }
        return $(regionSelect).append($(options));
      }
    }
  };
});
